import { NewDashboardOrgType } from 'helpers/repTypeHelper';

type VipView = 'vipStreet' | 'vipBlock';

type VipIdentity = {
  email: string;
  employeeId: string;
  orgType: NewDashboardOrgType;
};

/** Reps allowed to switch the leaderboard between the Street and Block orgs. */
const VIP_VIEWER_EMAILS = [
  'tyler.williams@sunrun.com',
  'jordan.williams@sunrun.com',
];

/**
 * The rep whose leaderboard is fetched for each VIP view. `orgType` drives the
 * table layout and the RunX status legend so both describe the org on screen.
 */
const VIP_IDENTITIES: Record<VipView, VipIdentity> = {
  vipStreet: {
    email: 'tyler.williams@sunrun.com',
    employeeId: '1317',
    orgType: 'STREET',
  },
  vipBlock: {
    email: 'leo.sagebin@sunrun.com',
    employeeId: '340630',
    orgType: 'BLOCK',
  },
};

const VIP_VIEW_OPTIONS: { label: string; value: VipView }[] = [
  { label: 'VIP - All Street', value: 'vipStreet' },
  { label: 'VIP - All Block', value: 'vipBlock' },
];

const DEFAULT_VIP_VIEW: VipView = 'vipStreet';

const isVipViewer = (email: string | undefined | null): boolean => {
  const normalized = email?.trim().toLowerCase();
  return !!normalized && VIP_VIEWER_EMAILS.includes(normalized);
};

export type { VipIdentity, VipView };
export {
  DEFAULT_VIP_VIEW,
  isVipViewer,
  VIP_IDENTITIES,
  VIP_VIEW_OPTIONS,
  VIP_VIEWER_EMAILS,
};
